export default __webpack_public_path__ + "static/media/wb-16.233809b8.webp";